var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import { DiagramConsts } from '../diagram-consts';
import { NodeElement } from './base/node-element';
import { GraphService } from '../../../../shared/gallery/graph.service';
import { ImageFillType } from '../../../view-data/components/image/image-fill-type';
import { ImageUrlHelper } from '../utils/imageUrlHelper';
var ImageElement = /** @class */ (function (_super) {
    __extends(ImageElement, _super);
    function ImageElement(injector) {
        var _this = _super.call(this, injector) || this;
        _this.graphService = injector.get(GraphService);
        return _this;
    }
    ImageElement.prototype.compile = function (model, data, svg) {
        svg.empty();
        model['version'] = 5;
        model['angle'] = data.angle;
        model['size'] = this.sizeService.parse(data.size);
        model['fillType'] = data.fillType;
        if (data.fillType === ImageFillType.Graph) {
            model['graphSetting'] = data.graphSetting;
        }
        else {
            var imageId = ImageUrlHelper.defaultImageId;
            var imageType = void 0;
            if (data.imageId) {
                imageId = data.imageId;
                if (data.imageType) {
                    imageType = data.imageType;
                }
            }
            else if (data.diagramSource) {
                // note:this code is used to make it compatible with old data, which image url was stored in 'diagramSouce' field
                var sourceUrl = data.diagramSource;
                var parsedImageId = ImageUrlHelper.getImageId(sourceUrl);
                if (parsedImageId) {
                    imageId = parsedImageId;
                    imageType = ImageUrlHelper.getImageType(sourceUrl);
                }
            }
            model['imageId'] = imageId;
            if (imageType) {
                model['imageType'] = imageType;
            }
        }
        if (this.hasDynamicSetting(data)) {
            model['dynamicSetting'] = data.dynamicSetting;
            model['location'] = go.Point.parse(data.loc);
            model['fixedPositionType'] = data.fixedPositionType;
        }
    };
    ImageElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.imageKey;
    };
    ImageElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/image.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    ImageElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', {
            rotatable: true,
            resizable: true, locationObjectName: 'IMAGE', locationSpot: go.Spot.TopLeft,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('rotatable', 'locked', function (locked) { return !locked; }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), 
        // can be resided according to the user's desires
        { resizable: true, resizeObjectName: 'IMAGE' }, 
        // TODO 图片是asp.net输出的，会导致图片不显示，暂时不设置sourceCrossOrigin。等后面改成直接从url文件读取的时候加上。
        $(go.Panel, 'Auto', $(go.Picture, { name: 'IMAGE' }, { sourceCrossOrigin: function (__) { return 'anonymous'; } }, new go.Binding('source', 'imageId', function (_, node) { return _this.getDesignerImageDisplayUrl(node.panel.panel.data); }), new go.Binding('source', 'graphSetting', function (setting, __) { return _this.graphService.getCustomStyleGraphUrl(setting); }), new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify))));
    };
    ImageElement.prototype.getDesignerImageDisplayUrl = function (nodeData) {
        if (nodeData.imageId && nodeData.imageId !== ImageUrlHelper.defaultImageId) {
            return ImageUrlHelper.buildImageUrl(nodeData.imageId, nodeData.imageType);
        }
        // note:this code is used to make it compatible with old data, which image url was stored in 'diagramSouce' field
        var sourceUrl = nodeData.diagramSource;
        if (sourceUrl && sourceUrl !== ImageUrlHelper.defaultImageSource) {
            return ImageUrlHelper.formatDesignerImageUrl(sourceUrl);
        }
        return ImageUrlHelper.defaultImageSource;
    };
    return ImageElement;
}(NodeElement));
export { ImageElement };
